import React from 'react';
import SearchMitreAttack from '../components/MitreAttack/SearchMitreAttack';
import { useSelector } from 'react-redux';
import { selectAuthProfiles } from '../redux/selectors/authSelectors';

const MitrePage = () => {
  const profiles = useSelector(selectAuthProfiles);

  if (
    !profiles?.mitre?.roles ||
    (profiles.mitre.roles.indexOf('curator') === -1 &&
      profiles.mitre.roles.indexOf('reader') === -1)
  ) {
    return null;
  }

  return (
    <SearchMitreAttack
      profile={profiles.mitre}
      profileSecondary={[
        profiles.news,
        profiles.cve,
        profiles.podcasts,
      ]}
      showAddWatchList={profiles.mitre.roles.indexOf('curator') > -1}
      showRemove={profiles.mitre.roles.indexOf('curator') > -1}
    />
  );
};

export default MitrePage;
